
import { LandingTile } from "../types/landingPage";

export const landingPageTiles: LandingTile[] = [
  {
    title: "User Guide",
    titleSlug: "user_guide",
    permalink: "1a73c8",
    path: "user_guide",
    icon: "/images/site_icons/user-guide-icon.svg",
    desc: "A guide to Domino for data scientists.",
    enableVersions: true,
    excludedVersions: [],
    // Title slug needs to be updated if docs are changed.
    tileContent: [
      {
        type: "internal",
        title: "Projects",
        titleSlug: "projects",
        permalink: "a8e081",
      },
      {
        type: "internal",
        title: "Workspaces",
        titleSlug: "workspaces",
        permalink: "867b72",
      },
      {
        type: "internal",
        title: "Apps",
        titleSlug: "publish-apps",
        permalink: "71635d",
      },
      {
        type: "internal",
        title: "Deploy models",
        titleSlug: "deploy-models",
        permalink: "08a85b",
      },
    ],
  },
  {
    title: "Admin Guide",
    titleSlug: "admin_guide",
    path: "admin_guide",
    icon: "/images/site_icons/admin-guide-icon.svg",
    desc: "Configure and manage Domino.",
    permalink: "b35e66",
    enableVersions: true,
    // TODO: query these data
    excludedVersions: [],
    tileContent: [
      {
        type: "internal",
        title: "Domino architecture",
        titleSlug: "architecture",
        permalink: "a0b173",
      },
      {
        type: "internal",
        title: "Configuration records",
        titleSlug: "central-configuration",
        permalink: "71d6ad",
      },
      {
        type: "internal",
        title: "Backup and restore",
        titleSlug: "backup-and-restore",
        permalink: "72ff13",
      },
      {
        type: "internal",
        title: "Kubernetes infrastructure",
        titleSlug: "kubernetes-infrastructure",
        permalink: "be5e54",
      },
    ],
  },
  {
    title: "API Guide",
    titleSlug: "api-guide",
    path: "api_guide",
    icon: "/images/site_icons/api-guide-icon.svg",
    desc: "A reference for data science developers.",
    permalink: "f35c19",
    enableVersions: true,
    excludedVersions: [],
    tileContent: [
      {
        type: "internal",
        title: "Domino Data API",
        titleSlug: "domino-data-api",
        permalink: "140b48",
      },
      {
        type: "internal",
        title: "The python-domino Library",
        titleSlug: "the-python-domino-library",
        permalink: "c5ef26",
      },
      {
        type: "internal",
        title: "REST API Reference (5.2+)",
        titleSlug: "rest-api-reference",
        permalink: "8c929e",
      },
      {
        type: "external",
        title: "Legacy APIs",
        href: "https://dominodatalab.github.io/api-docs/",
      },
    ],
  },
  {
    title: "Release Notes",
    titleSlug: "/release_notes/",
    path: "release_notes",
    icon: "/images/site_icons/release-notes-icon.svg",
    desc: "What's new in the latest Domino releases.",
    permalink: "41faed",
    enableVersions: false,
    excludedVersions: ["cloud","6.0"],
    tileContent: [
      {
        type: "internal",
        title: "5.6.2",
        titleSlug: "/release_notes/5-6-2/",
        permalink: "b4039e",
      },
      {
        type: "internal",
        title: "5.6.1",
        titleSlug: "/release_notes/5-6-1/",
        permalink: "78f412",
      },
      {
        type: "internal",
        title: "5.6.0",
        titleSlug: "/release_notes/5-6-0/",
        permalink: "6f899c",
      },
      {
        type: "internal",
        title: "5.5.4",
        titleSlug: "/release_notes/5-5-4/",
        permalink: "c23057",
      },
    ],
  },
];


